<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <layout-no-padding v-if="topLevelPages.length == 4">
        <v-flex xs12 sm6 md3 v-for="(item, i) in topLevelPages" :key="i" class="mb-4">
          <nav-dashboard-card :item="item"></nav-dashboard-card>
        </v-flex>
      </layout-no-padding>
      <layout-no-padding v-if="topLevelPages.length == 3">
        <v-flex xs12 sm6 md4 v-for="(item, i) in topLevelPages" :key="i" class="mb-4">
          <nav-dashboard-card :item="item"></nav-dashboard-card>
        </v-flex>
      </layout-no-padding>
      <layout-no-padding v-if="topLevelPages.length == 2">
        <v-flex xs12 sm6 v-for="(item, i) in topLevelPages" :key="i" class="mb-4">
          <nav-dashboard-card :item="item"></nav-dashboard-card>
        </v-flex>
      </layout-no-padding>
    </v-layout>
    <v-layout row wrap>
      <v-flex
        xs12
        sm6
        xl3
        v-for="(item) in $store.state.global.minorPages"
        :key="item.title"
        class="mb-4"
      >
        <nav-dashboard-minor-card :item="item"></nav-dashboard-minor-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import NavDashboardCard from "@/components/navigation/navDashboardCard.vue";
import NavDashboardMinorCard from "@/components/navigation/navDashboardMinorCard.vue";

export default {
  components: {
    NavDashboardCard,
    NavDashboardMinorCard
  },
  computed: {
    topLevelPages() {
      return this.$store.state.global.topLevelPages.filter(page => {
        //return ((page.link != 'user') && (page.link != 'tipping') && (page.link != 'tipping'))
        return page.showOnMainPage;
      });
    }
  }
};
</script>

<style>
</style>
